import React from 'react';
import { gameCardMechanicIcons } from '../utils/mechanicIcons';
import './GameCard.css';

export default function GameCard({ title, description, icon: Icon, onClick, color, questionCount, mechanic, mechanicKey, unplayed, style: externalStyle }) {
  const colorStyle = color
    ? {
        background: `linear-gradient(145deg, #fff 0%, ${color.bg} 100%)`,
        borderColor: color.border,
      }
    : {};
  const mergedStyle = { ...colorStyle, ...externalStyle };

  return (
    <div className="game-card" onClick={onClick} style={mergedStyle}>
      {unplayed && <span className="game-card-badge">NEW</span>}
      {Icon && <Icon className="game-card-icon" />}
      <h3>{title}</h3>
      <p>{description}</p>
      {mechanic && (
        <span className="game-card-mechanic">
          {gameCardMechanicIcons[mechanicKey] || null}
        </span>
      )}
      {questionCount > 0 && (
        <span className="game-card-count">
          <svg className="game-card-count-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="2" width="14" height="10" rx="2" fill="currentColor" opacity="0.5"/>
            <polygon points="5,12 8,12 6,15" fill="currentColor" opacity="0.5"/>
            <rect x="4" y="5" width="8" height="1.2" rx="0.6" fill="currentColor" opacity="0.3"/>
            <rect x="4" y="7.5" width="5" height="1.2" rx="0.6" fill="currentColor" opacity="0.3"/>
          </svg>
          {questionCount}
        </span>
      )}
    </div>
  );
}
